import { EntityDefinition } from 'types';

const definition = new EntityDefinition({
	singularName: 'Admin Profile',
	baseAjaxUrl: '/profile',
	baseRoute: '/profile',
});

export default definition;
